import { render, staticRenderFns } from "./ServiceClinicCard.vue?vue&type=template&id=18a29bea&scoped=true&"
import script from "./ServiceClinicCard.vue?vue&type=script&lang=js&"
export * from "./ServiceClinicCard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceClinicCard.vue?vue&type=style&index=0&id=18a29bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a29bea",
  null
  
)

export default component.exports